import { render, staticRenderFns } from "./DeRichTextView.vue?vue&type=template&id=2e16b66e&scoped=true"
import script from "./DeRichTextView.vue?vue&type=script&lang=js"
export * from "./DeRichTextView.vue?vue&type=script&lang=js"
import style0 from "./DeRichTextView.vue?vue&type=style&index=0&id=2e16b66e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e16b66e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e16b66e')) {
      api.createRecord('2e16b66e', component.options)
    } else {
      api.reload('2e16b66e', component.options)
    }
    module.hot.accept("./DeRichTextView.vue?vue&type=template&id=2e16b66e&scoped=true", function () {
      api.rerender('2e16b66e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/customComponent/DeRichTextView.vue"
export default component.exports